import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { Menubar } from 'primereact/menubar';
import Logout from "../pages/Logout"
import { UserContext } from '../hooks/UserContext';
import { isAdmin } from '../services/jwtRoles';

// Paths that count as "this item is active" beyond the item's own url.
const ALIASES = { '/editor': ['/'] };

const Header = () => {
  const { pathname } = useLocation();
  const { user } = useContext(UserContext);
  const isActive = (url) => pathname === url || (ALIASES[url] || []).includes(pathname);

  const items = [
    {
      label: 'Editor',
      icon: 'pi pi-fw pi-pencil',
      url: '/editor'
    },
    {
      label: 'Topics',
      icon: 'pi pi-fw pi-file',
      url: '/manage-topics'
    },
    {
      label: 'Categories',
      icon: 'pi pi-fw pi-tags',
      url: '/manage-categories'
    },
    {
      label: 'Popular',
      icon: 'pi pi-fw pi-star',
      url: '/manage-popular'
    },
    {
      label: 'Onboarding',
      icon: 'pi pi-fw pi-bookmark',
      url: '/manage-onboarding'
    },
    {
      label: 'Questions',
      icon: 'pi pi-fw pi-question',
      url: '/questions',
    },
    {
      label: 'Synonyms',
      icon: 'pi pi-fw pi-search',
      url: '/manage-synonyms',
    },
    {
      label: 'Hooks',
      icon: 'pi pi-fw pi-comment',
      url: '/manage-hooks',
    },
    {
      label: 'Links',
      icon: 'pi pi-fw pi-th-large',
      url: '/manage-links',
    },
    {
      label: 'Insights',
      icon: 'pi pi-fw pi-chart-bar',
      url: '/insights',
    },
    {
      label: 'Viewer',
      icon: 'pi pi-fw pi-eye',
      url: '/view'
    },
    // Admin-only: the server refuses the settings API to everyone else.
    ...(isAdmin(user?.token) ? [{
      label: 'Settings',
      icon: 'pi pi-fw pi-cog',
      url: '/settings',
    }] : []),
  ];

  const model = items.map(item => (
    isActive(item.url) ? { ...item, className: 'nav-active' } : item
  ));

  return (
    <div>
      <style>{`
        .p-menubar .p-menubar-root-list > .p-menuitem {
          margin: 0 0.25rem;
        }
        .p-menubar .p-menubar-root-list > .p-menuitem > .p-menuitem-link {
          border-radius: 6px;
        }
        .p-menubar .p-menuitem.nav-active > .p-menuitem-link {
          background-color: rgba(33, 150, 243, 0.12);
        }
        .p-menubar .p-menuitem.nav-active > .p-menuitem-link .p-menuitem-text,
        .p-menubar .p-menuitem.nav-active > .p-menuitem-link .p-menuitem-icon {
          color: #1976D2;
        }
      `}</style>
      <div className="card">
        <Menubar model={model} end={<Logout />} />
      </div>
    </div>
  );
}


export default Header;
